module.exports = __webpack_public_path__ + "static/media/Prepare-meeting.2026e547.svg";